// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-pop-ballon {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.container-pop-ballon .btn-pop-ballon {
  border-radius: 10px;
  height: 6vh !important;
  width: 80%;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}
.txt-number-ballon {
  text-align: center;
}
.color-ui {
  color: #6495ED;
}
.card-pop-ballon {
  border-radius: 12px;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.3);
  margin-bottom: 2%;
  min-width: 380px;
  max-width: 380px;
}
.card-pop-ballon .btn-card-pop-ballon {
  text-align: center;
  margin-top: 8px;
  margin-bottom: 8px;
}
.modal-pop-ballon .ant-modal-close {
  inset-inline-end: 4% !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/PopBallon/ShowcasePopBallon/showcasePopBallon.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AALA;EAQI,mBAAA;EACA,sBAAA;EACA,UAAA;EACA,2CAAA;AAAJ;AAKA;EACE,kBAAA;AAHF;AAMA;EACE,cAAA;AAJF;AAOA;EACE,mBAAA;EACA,0CAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AALF;AAAA;EAQI,kBAAA;EACA,eAAA;EACA,kBAAA;AALJ;AASA;EACE,+BAAA;AAPF","sourcesContent":[".container-pop-ballon {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n\n  .btn-pop-ballon {\n    border-radius: 10px;\n    height: 6vh !important;\n    width: 80%;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  }\n\n}\n\n.txt-number-ballon {\n  text-align: center;\n}\n\n.color-ui {\n  color: #6495ED;\n}\n\n.card-pop-ballon {\n  border-radius: 12px;\n  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.3);\n  margin-bottom: 2%;\n  min-width: 380px;\n  max-width: 380px;\n\n  .btn-card-pop-ballon {\n    text-align: center;\n    margin-top: 8px;\n    margin-bottom: 8px;\n  }\n}\n\n.modal-pop-ballon .ant-modal-close {\n  inset-inline-end: 4% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
